// 粉圈黑话词典数据

export interface GlossaryTerm {
  term: string;
  tag: string;
  meaning: string;
  example: string;
}

export const glossaryTerms: GlossaryTerm[] = [
  {
    term: "塌房",
    tag: "核心词",
    meaning:
      "指艺人长期经营的正面人设因突发事件在短时间内崩塌，令粉丝与大众产生幻灭感的现象。重点在反差与信任崩塌，而非单纯的负面新闻。",
    example: "多年舞台人设因一次负面爆料彻底崩盘，粉丝感叹偶像塌房太快。",
  },
  {
    term: "脱粉",
    tag: "立场",
    meaning:
      "停止喜欢一位艺人，通过取关、删号、移除粉丝牌、停止打榜等动作，主动切断原有的情感与数据投入。",
    example: "塌房后她连夜取关并移除了所有粉丝牌，算是正式脱粉了。",
  },
  {
    term: "回踩",
    tag: "立场",
    meaning:
      "脱粉后反过来主动翻旧账、晒消费与应援记录、写长文复盘，甚至参与负面传播。常由被辜负的情绪驱动，由爱转恨。",
    example: "与其被动接受，不如把多年账目晒出来，这就是典型的回踩动作。",
  },
  {
    term: "站姐",
    tag: "核心词",
    meaning:
      "长期蹲守机场、舞台等前线，以专业相机拍摄并运营艺人图频账号的粉丝。掌握高价值物料，是粉圈中信任度与影响力都较高的一类人。",
    example: "那位跟了两年的站姐发图一直很稳，塌房后却一夜之间清空了账号。",
  },
  {
    term: "超话",
    tag: "阵地",
    meaning:
      "粉丝在平台内开设的专属讨论话题空间，承担签到、打投、安利与组织功能，是粉圈的数据阵地与舆论前线。",
    example: "塌房后的超话签到人数肉眼可见地往下掉。",
  },
  {
    term: "后援会",
    tag: "组织",
    meaning:
      "由核心粉丝组成的应援组织，负责应援、集资、行程对接与对外发声，常以官方身份在关键时刻表态，是粉圈的组织中枢。",
    example: "后援会连夜改声明，会员之间吵成一团。",
  },
  {
    term: "顶流",
    tag: "圈层",
    meaning:
      "指人气、数据与商业价值均位居头部的当红艺人。顶流的塌房因为基数大、期待高，往往引发更剧烈的舆论连锁反应。",
    example: "顶流一旦塌房，波及的粉圈和商业合作都是量级的。",
  },
  {
    term: "唯粉",
    tag: "圈层",
    meaning:
      "只专注支持团队中某一个成员的粉丝，忠诚度与数据投入通常较高，也是塌房时情绪反应最强烈的人群之一。",
    example: "作为唯粉，她只打投这一个成员的榜单。",
  },
  {
    term: "路人缘",
    tag: "圈层",
    meaning:
      "指不追星的普通观众对艺人的好感度，是支撑商业价值与作品口碑的重要底盘，也是塌房后最容易流失的部分。",
    example: "路人缘一旦崩坏，单纯靠粉丝很难撑起口碑。",
  },
  {
    term: "出坑",
    tag: "立场",
    meaning:
      "与脱粉相近但更强调阶段性，指粉丝主动退出当前追星状态，可能不再追同一位艺人，也可能彻底离开粉圈。",
    example: "看清真相之后，她决定就此出坑，不再参与任何打投。",
  },
  {
    term: "关站",
    tag: "动作",
    meaning:
      "站姐或粉丝运营者关闭、注销或永久停更自己的应援账号，是塌房后最彻底的立场表达之一。",
    example: "运营多年的单人站连夜关站，评论区挤满了来确认的粉丝。",
  },
  {
    term: "广场",
    tag: "阵地",
    meaning:
      "借指超话或关键词下的公共讨论区域，是舆论交锋的第一现场，常被用来衡量话题的正面或负面氛围。",
    example: "回踩和复盘的内容占领广场，风向一下子就变了。",
  },
  {
    term: "毒唯",
    tag: "圈层",
    meaning:
      "对单一成员极度忠诚、常攻击队友或异见者的极端唯粉，情绪化程度高，塌房时可能走向更偏激的表达。",
    example: "评论区里的毒唯还在无差别攻击质疑的声音。",
  },
  {
    term: "情绪价值",
    tag: "心理",
    meaning:
      "追星带来的陪伴、认同与寄托。塌房本质上是被剥夺了预期的情绪价值，这也解释了为何粉丝反应如此激烈。",
    example: "大家追的不是偶像本身，而是他提供的情绪价值。",
  },
];